module.exports = __webpack_public_path__ + "static/img/map_fujian.eeca2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_fujian.png
// module id = dzQs
// module chunks = 0